import React, { useContext } from "react";
import { Route, Navigate } from "react-router-dom";
import AuthLayout from "../layouts/auth/index";
import { PayLoadCtx, RoleCtx } from "../lib/context";
const AdminRoute = ({ children }) => {
    const { payload } = useContext(PayLoadCtx);
    const { role } = useContext(RoleCtx);
    return payload && (role === "CA" || role === "SA") ? <AuthLayout role="Admin">{children}</AuthLayout> : <Navigate to="/" />;
};

export default AdminRoute;
